<div class="ImgDecode"><input type="file" (change)="decodeImg($event)" /></div>
